// Pre-rendered Kokoro af_heart speech; scheduled on the existing Web Audio clock.
export default {
  "Shuttle test": "/audio/tests/v3/c6a92c31baf82086.wav",
  "Three": "/audio/tests/v3/926f52d1c1e19c0c.wav",
  "Two": "/audio/tests/v3/94a72c074cfe5747.wav",
  "One": "/audio/tests/v3/8b12507783d5beca.wav",
  "Level two": "/audio/tests/v3/6f1d6f49fe8ec9ad.wav",
  "Level three": "/audio/tests/v3/6248c84015e720e0.wav",
  "Level four": "/audio/tests/v3/9f02c32390c5ced3.wav",
  "Level five": "/audio/tests/v3/a0695a6b67631286.wav",
  "Level six": "/audio/tests/v3/f90f938e77373095.wav",
  "Level seven": "/audio/tests/v3/fad6b711b0bac88b.wav",
  "Level eight": "/audio/tests/v3/0777f01929b1673f.wav",
  "Level nine": "/audio/tests/v3/602478be73db5e70.wav",
  "Level ten": "/audio/tests/v3/9ccf78919f32ab6a.wav",
  "Level eleven": "/audio/tests/v3/1a3e687bfba4acf7.wav",
  "Level twelve": "/audio/tests/v3/7a3d55ce708bf44c.wav",
  "Level thirteen": "/audio/tests/v3/695d16cf9166fdad.wav",
  "Level fourteen": "/audio/tests/v3/7bc20a3b64359b75.wav",
  "Level fifteen": "/audio/tests/v3/4bfdef7bffc1c6b6.wav",
  "Level sixteen": "/audio/tests/v3/2889d3a870dd7da3.wav",
  "Level seventeen": "/audio/tests/v3/5af387131f3623f3.wav",
  "Level eighteen": "/audio/tests/v3/ab9d143e9a32c8c1.wav",
  "Level nineteen": "/audio/tests/v3/50ee6234aef6a594.wav",
  "Level twenty": "/audio/tests/v3/8e4d565dac004322.wav",
  "Level twenty one": "/audio/tests/v3/bda9660ddca48621.wav",
  "Test finished": "/audio/tests/v3/76a733f443e43fd2.wav",
  "Yo Yo test": "/audio/tests/v3/315a543c1933e69c.wav",
  "Recovery": "/audio/tests/v3/48f6a8d5688b0cf5.wav",
  "Level nine point one": "/audio/tests/v3/afd180727d81cb16.wav",
  "Level eleven point one": "/audio/tests/v3/980cb8f94eb3c5ee.wav",
  "Level eleven point two": "/audio/tests/v3/289f1ab79fa06b48.wav",
  "Level twelve point one": "/audio/tests/v3/da34a86b2a1820f5.wav",
  "Level twelve point two": "/audio/tests/v3/222bcc2734aae059.wav",
  "Level twelve point three": "/audio/tests/v3/a254412809bc2b72.wav",
  "Level thirteen point one": "/audio/tests/v3/eb38591a3966e856.wav",
  "Level thirteen point two": "/audio/tests/v3/dce2e601e3dd03a2.wav",
  "Level thirteen point three": "/audio/tests/v3/1bfa8db2cc698859.wav",
  "Level thirteen point four": "/audio/tests/v3/daa2d2eb47159c5f.wav",
  "Level fourteen point one": "/audio/tests/v3/4a613937f60dfb58.wav",
  "Level fourteen point two": "/audio/tests/v3/ec4c0776ea2312e4.wav",
  "Level fourteen point three": "/audio/tests/v3/e663a0a787d82f64.wav",
  "Level fourteen point four": "/audio/tests/v3/0ea7ea03217183e0.wav",
  "Level fourteen point five": "/audio/tests/v3/fb73be1fb79c2438.wav",
  "Level fourteen point six": "/audio/tests/v3/ee3160a928f1bd99.wav",
  "Level fourteen point seven": "/audio/tests/v3/cc50550d67d6df09.wav",
  "Level fourteen point eight": "/audio/tests/v3/4e6b44ebbb5718ce.wav",
  "Level fifteen point one": "/audio/tests/v3/742d95480964657a.wav",
  "Level fifteen point two": "/audio/tests/v3/e67bae369a50b5ba.wav",
  "Level fifteen point three": "/audio/tests/v3/c2358535afed0dc3.wav",
  "Level fifteen point four": "/audio/tests/v3/e70c2996afa8390f.wav",
  "Level fifteen point five": "/audio/tests/v3/e1510942a38ec667.wav",
  "Level fifteen point six": "/audio/tests/v3/244003314c190138.wav",
  "Level fifteen point seven": "/audio/tests/v3/c80cf827035fc9e7.wav",
  "Level fifteen point eight": "/audio/tests/v3/954792927ad7a2f6.wav",
  "Level sixteen point one": "/audio/tests/v3/77121e741200e4d5.wav",
  "Level sixteen point two": "/audio/tests/v3/4e09a36af16581b3.wav",
  "Level sixteen point three": "/audio/tests/v3/ee35763054ddbfda.wav",
  "Level sixteen point four": "/audio/tests/v3/dec98dcacda4063f.wav",
  "Level sixteen point five": "/audio/tests/v3/6286a514e79c5521.wav",
  "Level sixteen point six": "/audio/tests/v3/92c3878786f18984.wav",
  "Level sixteen point seven": "/audio/tests/v3/14bd7f2a1e3ddc22.wav",
  "Level sixteen point eight": "/audio/tests/v3/fd43c0fe692c61b4.wav",
  "Level seventeen point one": "/audio/tests/v3/156bdb87561bc962.wav",
  "Level seventeen point two": "/audio/tests/v3/ffd39a69e102e57b.wav",
  "Level seventeen point three": "/audio/tests/v3/590597c5447dbd38.wav",
  "Level seventeen point four": "/audio/tests/v3/9641cb5e848aa26c.wav",
  "Level seventeen point five": "/audio/tests/v3/0402c51963b9d749.wav",
  "Level seventeen point six": "/audio/tests/v3/6ce8d23b694947c5.wav",
  "Level seventeen point seven": "/audio/tests/v3/a55c9d7046b7f6e7.wav",
  "Level seventeen point eight": "/audio/tests/v3/e7e3d813c05fa048.wav",
  "Level eighteen point one": "/audio/tests/v3/8d6befd2126b46dc.wav",
  "Level eighteen point two": "/audio/tests/v3/0a717f7b05f90d46.wav",
  "Level eighteen point three": "/audio/tests/v3/87b031916673f36b.wav",
  "Level eighteen point four": "/audio/tests/v3/c58572c32bcb257b.wav",
  "Level eighteen point five": "/audio/tests/v3/78f4d937fead39e4.wav",
  "Level eighteen point six": "/audio/tests/v3/604086e21df3c387.wav",
  "Level eighteen point seven": "/audio/tests/v3/7c2cd855c62acb7c.wav",
  "Level eighteen point eight": "/audio/tests/v3/228b6eb53a66b994.wav",
  "Level nineteen point one": "/audio/tests/v3/04363346b8be021a.wav",
  "Level nineteen point two": "/audio/tests/v3/670d801a05371b75.wav",
  "Level nineteen point three": "/audio/tests/v3/90a18f7d7d9878be.wav",
  "Level nineteen point four": "/audio/tests/v3/86d4f85c3f0cd283.wav",
  "Level nineteen point five": "/audio/tests/v3/a7f0d63bed025139.wav",
  "Level nineteen point six": "/audio/tests/v3/e338302053de7f60.wav",
  "Level nineteen point seven": "/audio/tests/v3/c39f0bee4d5eafdc.wav",
  "Level nineteen point eight": "/audio/tests/v3/32a5a4390aa848bb.wav",
  "Level twenty point one": "/audio/tests/v3/42f87f9a2f5d8502.wav",
  "Level twenty point two": "/audio/tests/v3/4b68d3ad164d3285.wav",
  "Level twenty point three": "/audio/tests/v3/daede645041c7f84.wav",
  "Level twenty point four": "/audio/tests/v3/85e3fba1b3fe6631.wav",
  "Level twenty point five": "/audio/tests/v3/e7dd7dab4cfe2709.wav",
  "Level twenty point six": "/audio/tests/v3/2e60daf47285ecd5.wav",
  "Level twenty point seven": "/audio/tests/v3/a60e0b649eea2283.wav",
  "Level twenty point eight": "/audio/tests/v3/f1ed8f26420972fb.wav",
  "Level twenty one point one": "/audio/tests/v3/79f24d4c7ec38629.wav",
  "Level twenty one point two": "/audio/tests/v3/49e82dbfc4931c8f.wav",
  "Level twenty one point three": "/audio/tests/v3/2e22e2e7cdb49d2a.wav",
  "Level twenty one point four": "/audio/tests/v3/a73529e2c8c044d2.wav",
  "Level twenty one point five": "/audio/tests/v3/48863ad508b9ce87.wav",
  "Level twenty one point six": "/audio/tests/v3/8d5bf0506ada6924.wav",
  "Level twenty one point seven": "/audio/tests/v3/d1ab993192fee237.wav",
  "Level twenty one point eight": "/audio/tests/v3/6ed0bf0c7e48c5ed.wav",
  "Level twenty two point one": "/audio/tests/v3/5d7225cce6379265.wav",
  "Level twenty two point two": "/audio/tests/v3/f58c0a708a3b675f.wav",
  "Level twenty two point three": "/audio/tests/v3/b31ba5044f102682.wav",
  "Level twenty two point four": "/audio/tests/v3/6d6c322748c447f7.wav",
  "Level twenty two point five": "/audio/tests/v3/0b705380030565fc.wav",
  "Level twenty two point six": "/audio/tests/v3/62009ceca42cd32a.wav",
  "Level twenty two point seven": "/audio/tests/v3/4ec8c943ec91aa86.wav",
  "Level twenty two point eight": "/audio/tests/v3/fdf009c2caa2ed5b.wav",
  "Level twenty three point one": "/audio/tests/v3/7e45613ea157945e.wav",
  "Level twenty three point two": "/audio/tests/v3/df7435183c802ae9.wav",
  "Level twenty three point three": "/audio/tests/v3/1a812a54686f9404.wav",
  "Level twenty three point four": "/audio/tests/v3/8bde582b4b5c6d16.wav",
  "Level twenty three point five": "/audio/tests/v3/46947ad1ad3e6eaf.wav",
  "Level twenty three point six": "/audio/tests/v3/ef42eec7f8c903c2.wav",
  "Level twenty three point seven": "/audio/tests/v3/88ad31b035d671f1.wav",
  "Level twenty three point eight": "/audio/tests/v3/36874cf629566fb1.wav"
};
